import { render } from "./AlertsList.vue?vue&type=template&id=57121164&scoped=true"
import script from "./AlertsList.vue?vue&type=script&lang=js"
export * from "./AlertsList.vue?vue&type=script&lang=js"

import "./AlertsList.vue?vue&type=style&index=0&id=57121164&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57121164"]])

export default __exports__